import React from 'react';
import AddOnCard from './AddOns/AddOnCard';

type MkpPlanCardV2Props = {
  hasAdvancedMode: boolean;
  numTenants: number;
  maxTenants: number;
  zIndex: number;
};
const MkpPlanCardV2 = ({ hasAdvancedMode, numTenants, maxTenants, zIndex }: MkpPlanCardV2Props) => (
  <AddOnCard
    title="My Kentik Portal"
    description={`KD-MT${hasAdvancedMode ? '-ADV' : ''}`}
    extensions={[
      { key: 'MKP Tenants', value: `${numTenants} of ${hasAdvancedMode ? 'Unlimited' : maxTenants}` },
      { key: 'Advanced Feature Set', value: hasAdvancedMode ? 'Enabled' : 'Disabled' }
    ]}
    zIndex={zIndex}
  />
);

export default MkpPlanCardV2;
